import { useState, useEffect } from 'react';
import { Heading, Text, Button } from '../../atoms';
import { useLanguage } from '../../../context/LanguageContext';
import './Hero.css';

const HERO_IMAGES = [
  '/img/patriciaTribunales.jpeg',
  '/img/casaRosa.jpg',
  '/img/congreso.jpg',
  '/img/ingenieros.jpg',
];

const CAROUSEL_INTERVAL_MS = 5000;

function Hero() {
  const { t } = useLanguage();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, CAROUSEL_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <section id="home" className="hero" aria-label="Welcome">
      <div className="hero__carousel" aria-hidden>
        {HERO_IMAGES.map((src, index) => (
          <div
            key={src}
            className={`hero__slide ${index === activeIndex ? 'hero__slide--active' : ''}`}
            style={{ backgroundImage: `url(${src})` }}
          />
        ))}
      </div>
      <div className="hero__overlay" />
      <div className="hero__content">
        <Heading level={1} className="hero__title">
          {t('hero.title')}
        </Heading>
        <Text size="large" className="hero__subtitle">
          {t('hero.subtitle')}
        </Text>
        <div className="hero__actions">
          <Button href="#contact" variant="accent">{t('hero.cta')}</Button>
        </div>
      </div>
    </section>
  );
}

export default Hero;
